/**
 * Enum for the different logical operator applied to source filters
 * @enum {string}
 * @readonly
 */
export const FiltersLogicalOperators = Object.freeze({
  AND: 'and',
  OR: 'or'
});
